import Api from "@/services/Api";
import SystemConst from "@/config/const";

export default {
  getSalons(params: object) {
    return Api().get("/users/salons", { params: params });
  },
  redirectQr(params: object) {
    return Api().get("/users/salons/dynamic_qr", { params: params });
  },
  getTickets(salon_id: any, params: object = {}) {
    return Api().get(`/users/salons/${salon_id}/tickets`, { params: params });
  },
  getSecretTickets(query: any) {
    let url = `/users/salons/secret_tickets?token=${query.token}&page=${query.page}&per_page=${query.per_page}`;
    if (
      query.ticket_type &&
      query.ticket_type !== SystemConst.TICKET_TYPE_ALL
    ) {
      url += `&ticket_type=${query.ticket_type}`;
    }
    return Api().get(url);
  },
  getSalonAndTicket(salon_id: string, ticket_id: string, params: object = {}) {
    return Api().get(`/users/salons/${salon_id}/tickets/${ticket_id}`, { params: params});
  },
  listSalonViewed(query: any) {
    let url = `/users/salons/list_viewed?page=${query.page}&per_page=${query.per_page}`;
    if (query.salon_genre && query.salon_genre !== SystemConst.SALON_TYPE_ALL) {
      url += `&salon_genre=${query.salon_genre}`;
    }
    return Api().get(url);
  },
  createViewedSalon(params: object = {}) {
    return Api().post("users/salon_histories", params);
  }
};
